import React from 'react';

const RestrictedAccess = () =>
(
  <div>
    <h1>You do not have the permissions to access this site</h1>
    <p>Please follow the below steps to raise the request.</p>
    <ul>
      <li> Open <a href="https://cat.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=a973fc6d1b3d8c146ec90fe7cc4bcbf0" target="_blank"  rel="noreferrer">ServiceNow portal</a> </li>
      <li> In the opened page add your Name in the requested for field</li>
      <li> Select <u>Other</u> option under the nature of request</li>
      <li> Add your CWS id and business justification and the role access you need in the <u>Desciption</u></li>
      <li> Add <u>IOT Gateway Support UI</u> in the service feild</li>
      <li> Add <u>Helios IoT GW Support UI</u> in the assignement group. </li>
      <li> Click on <u>Order Now</u> option.</li>
      <p>An email will be send to us and the permission will be granted after validating the request.</p>
      Please follow the <a href="https://catdigital.atlassian.net/wiki/spaces/CD/pages/1928203847/Support+UI+Onboarding" target="_blank"  rel="noreferrer">confluence page</a> for the same.
    </ul>
  </div>
);

export default RestrictedAccess;